import { medtechApiClient } from '.';
import {
  DocumentAssessmentValidateInput,
  DocumentAssessmentValidateOutput,
  DocumentAssessmentValidateOutputModel,
} from './model/training';

export const trainingApi = {
  async validateDocumentAssessment(
    companyId: number,
    documentId: number,
    payload: DocumentAssessmentValidateInput,
  ): Promise<DocumentAssessmentValidateOutput> {
    const url = `/v2/${companyId}/documents/${documentId}/assessment/validate`;
    const resp = await medtechApiClient.put(url, payload);
    try {
      if (resp.status === 200) {
        return await DocumentAssessmentValidateOutputModel.parseAsync(
          resp.data,
        );
      }
      return {
        slug: 'error',
        message: resp.data.message,
      };
    } catch (error) {
      return {
        slug: 'error',
        message: resp.data.message,
      };
    }
  },
};
